import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Token } from "../../model/token";
import { environment } from "src/environments/environment";
import { tap } from "rxjs/operators";

@Injectable()
export class AuthService {
  private _token: Token;
  enc = btoa(`${environment.oauthClient}:${environment.oauthSecret}`);
  // iat : number; // data di emissione
  exp: number; // data di scadenza
  toleranceBeforeExpiration = 2700000; // era 900000 millis = 15 minuti
  refreshingToken = false;

  constructor(private http: HttpClient) {}

  post(user: string, pass: string) {
    return this.http
      .post<Token>(`${environment.baseUrl}/oauth/token`, null, {
        headers: { Authorization: `Basic ${this.enc}` },
        params: { username: user, password: pass, grant_type: "password" },
      })
      .pipe(
        tap((token: Token) => {
          this.token = token;
          // aggiorna iat e exp
          // this.updateExp();
          // this.refreshToken().subscribe();
        })
      );
  }

  // Refresha il token
  refreshToken() {
    return this.http
      .post<Token>(`${environment.baseUrl}/oauth/token`, null, {
        headers: { Authorization: `Basic ${this.enc}` },
        params: {
          access_token: this.token.access_token,
          refresh_token: this.token.refresh_token,
          grant_type: "refresh_token",
        },
        // params: { 'refresh_token': this.token.refresh_token, 'grant_type': 'refresh_token' }
      })
      .pipe(
        tap((token: Token) => {
          this.token = token;
          // aggiorna iat e exp
          // this.updateExp();
        })
      );
  }

  // Controlla se il token sta scadendo, e lo refresha in caso
  checkAndRefreshToken() {
    this.http
      .post<Token>(`${environment.baseUrl}/oauth/check_token`, null, {
        headers: { Authorization: `Basic ${this.enc}` },
        params: { token: this.token.access_token },
      })
      .pipe(
        tap((token_info: any) => {
          // this.token = token;
          // aggiorna iat e exp
          // this.updateExp();
          const lasso = (token_info.exp * 1000 - new Date().getTime()) / 1000;
          if (lasso < 3000 && !this.refreshingToken) {
            this.refreshingToken = true;
            this.refreshToken().subscribe(() => {
              this.refreshingToken = false;
            });
          }
        })
      )
      .subscribe();
  }

  // Controlla se il token sta scadendo, e lo refresha in caso
  checkToken() {
    this.http
      .post<Token>(`${environment.baseUrl}/oauth/check_token`, null, {
        headers: { Authorization: `Basic ${this.enc}` },
        params: { token: this.token.access_token },
      })
      .pipe(
        tap((token_info: any) => {
          // this.token = token;
          // aggiorna iat e exp
          // this.updateExp();
          const lasso = (token_info.exp * 1000 - new Date().getTime()) / 1000;
        })
      )
      .subscribe();
  }

  // controlla se il token si sta avvicinando alla scadenza
  // isTokenExpiring() : boolean {
  //     let d = new Date();
  //     let n = d.getMilliseconds();
  //     if(this.exp - n < this.toleranceBeforeExpiration) {
  //         return true;
  //     }
  //     return false;
  // }

  // controlla se il token si sta avvicinando alla scadenza
  updateExp() {
    this.http
      .post<any>(`${environment.baseUrl}/oauth/check_token`, null, {
        headers: { Authorization: `Basic ${this.enc}` },
        params: { token: this.token.access_token },
      })
      .subscribe((tokenInfo) => {
        this.exp = tokenInfo.exp * 1000;
        // aggiorna iat e exp
      });
  }

  set token(token: Token) {
    if (token) sessionStorage.setItem("Token", JSON.stringify(token));
    else sessionStorage.removeItem("Token");
    this._token = token;
  }

  get token(): Token {
    if (!this._token) this._token = JSON.parse(sessionStorage.getItem("Token"));
    return this._token;
  }
}
